export default "__VITE_ASSET__a2639d24__"